class CountryDetector {
  constructor() {
    this.providers = [
      this.tryCloudflare.bind(this),
      this.tryIpApi.bind(this),
      this.tryIpApiCo.bind(this),
      this.tryBrowserLanguage.bind(this)
    ];
    this.cacheKey = 'userCountryCache';
  }

  async tryCloudflare() {
    try {
      const response = await fetch('https://country-detection.workers-demo.workers.dev/');
      const data = await response.json();
      return data.country;
    } catch (error) {
      throw new Error('Cloudflare failed');
    }
  }

  async tryIpApi() {
    try {
      const response = await fetch('https://ip-api.com/json/?fields=countryCode');
      const data = await response.json();
      if (data && data.countryCode) {
        return data.countryCode;
      }
      throw new Error('No country data');
    } catch (error) {
      throw new Error('ip-api failed');
    }
  }

  async tryIpApiCo() {
    try {
      const response = await fetch('https://ipapi.co/country/');
      const country = await response.text();
      if (country && country.length === 2) {
        return country;
      }
      throw new Error('Invalid country code');
    } catch (error) {
      throw new Error('ipapi.co failed');
    }
  }

  tryBrowserLanguage() {
    const language = navigator.language || navigator.userLanguage || 'en-US';
    const countryCode = language.split('-')[1] || language.split('_')[1] || 'US';
    return countryCode.toUpperCase();
  }

  getCachedCountry() {
    try {
      const cached = localStorage.getItem(this.cacheKey);
      if (!cached) return null;

      const { country, timestamp } = JSON.parse(cached);

      if (Date.now() - timestamp < this.cacheDuration) {
        return country;
      }

      localStorage.removeItem(this.cacheKey);
      return null;
    } catch (error) {
      return null;
    }
  }

  setCachedCountry(country) {
    try {
      const cacheData = {
        country: country,
        timestamp: Date.now()
      };
      localStorage.setItem(this.cacheKey, JSON.stringify(cacheData));
    } catch (error) {
    }
  }

  async getCountry() {
    const cached = this.getCachedCountry();
    if (cached) {
      console.log('Using cached country:', cached);
      return cached;
    }

    for (const provider of this.providers) {
      try {
        const country = await provider();
        if (country && typeof country === 'string' && country.length === 2) {
          this.setCachedCountry(country);
          return country;
        }
      } catch (error) {
        console.warn(`${provider.name} failed, trying next...`);
        continue;
      }
    }

    return 'US';
  }

  async refreshCountry() {
    localStorage.removeItem(this.cacheKey);
    return await this.getCountry();
  }
}

class ProductEmbroidery extends HTMLElement {
  constructor() {
    super()

    this.enabled = this.querySelector('#embroidery-personalize')
    this.$container = this.querySelector('.product-embroidery__wrapper')
    this.$input = this.querySelector('.product-embroidery__input')
    this.$colors = this.querySelectorAll('.product-embroidery__color')
    this.$activeColor = this.querySelector('.product-embroidery__selected')
    this.$count = this.querySelector('.product-embroidery__characters-count')

    this.onChangeEnabled = this.onChangeEnabled.bind(this)
    this.onInputCharacters = this.onInputCharacters.bind(this)
    this.onSelectColor = this.onSelectColor.bind(this)
  }

  addEvents() {
    this.enabled.addEventListener('change', this.onChangeEnabled)
    this.$input.addEventListener('input', this.onInputCharacters)

    this.$colors.forEach($color => {
      $color.addEventListener('change', this.onSelectColor)
    }, false)
  }

  removeEvents() {
    this.enabled.removeEventListener('change', this.onChangeEnabled)
    this.$input.removeEventListener('input', this.onInputCharacters)

    this.$colors.forEach($color => {
      $color.removeEventListener('change', this.onSelectColor)
    }, false)
  }

  checkVisibility() {
    const countryDetector = new CountryDetector();
    countryDetector.getCountry().then(country => {
      if (country == 'US') {
        this.classList.remove('hidden')
        this.addEvents()
      }
    });
  }

  connectedCallback() {
    this.checkVisibility()
  }

  disconnectedCallback() {
    this.removeEvents()
  }

  onChangeEnabled(event) {
    this.$finalSaleMessage = document.querySelector('.final-sale-message')

    if (event.target.checked) {
      this.$container.classList.remove('hidden')
      setTimeout(() => {
        this.$input.focus()
      }, 50)

      this.$finalSaleMessage.classList.remove('hide')
    } else {
      this.$container.classList.add('hidden')
      this.$input.value = ''

      if (this.$finalSaleMessage.dataset.finalSale !== 'true') {
        this.$finalSaleMessage.classList.add('hide')
      }
    }
  }

  onInputCharacters(event) {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/g, '')

    const count = event.target.value.length
    this.$count.innerHTML = count
  }

  onSelectColor(event) {
    const label = event.target.getAttribute('aria-label')
    this.$activeColor.innerHTML = label
  }
}

if (typeof customElements.get('product-embroidery') === 'undefined') {
  customElements.define('product-embroidery', ProductEmbroidery)
}
